module.exports = __webpack_public_path__ + "img/business_05.8e231fe1.jpg";